import React, {Fragment, Component} from 'react'
import {withAuth0} from "@auth0/auth0-react";
import {connect} from "react-redux";
import NavigationCardView from "../components/NavigationCardView";
import {getOtherUsersLoanProposal, getOtherUsersLoanRequest} from "../utils/api/loanAPI";


class NavigationCardContainer extends Component{
    state = {
        numRequests: 0,
        numProposals: 0,
    }
    componentDidMount() {
        this.retrieveToken()
            .then(token=>{
                getOtherUsersLoanRequest(token)
                    .then(r => {
                        this.setState({
                            numRequests: r.length
                        })
                    })
                getOtherUsersLoanProposal(token)
                    .then(r=>{
                        this.setState({
                            numProposals: r.length
                        })
                    })
            })
    }

    async retrieveToken(){
        const {getAccessTokenSilently} = this.props.auth0
        let accessToken;
        try{
            accessToken = await getAccessTokenSilently()
        }catch (e){
            console.error(e);
        }
        return accessToken;
    }

    render() {
        const {connection, balance} = this.props
        return(
            <NavigationCardView
                connections={Object.keys(connection).length}
                numberRequests={this.state.numRequests}
                numberProposals={this.state.numProposals}
                balance={balance.availableBalance}
            />
        )
    }
}
function mapStateToProps(state){
    return{
        connection:state.connection,
        balance: state.balance
    }
}
export default connect(mapStateToProps)(withAuth0(NavigationCardContainer))